module.exports = __webpack_public_path__ + "img/GMOS6-1.8b882b22.png";